/**
 * Manages request and response interceptors for HTTP operations
 */
export class InterceptorManager {
    constructor() {
        this.requestInterceptors = [];
        this.responseInterceptors = [];
    }
    /**
     * Adds a request interceptor
     *
     * @param interceptor - Function to run before each request
     * @returns Cleanup function to remove the interceptor
     */
    addRequestInterceptor(interceptor) {
        this.requestInterceptors.push(interceptor);
        return () => {
            const index = this.requestInterceptors.indexOf(interceptor);
            if (index > -1) {
                this.requestInterceptors.splice(index, 1);
            }
        };
    }
    /**
     * Adds a response interceptor
     *
     * @param interceptor - Function to run after each successful response
     * @returns Cleanup function to remove the interceptor
     */
    addResponseInterceptor(interceptor) {
        this.responseInterceptors.push(interceptor);
        return () => {
            const index = this.responseInterceptors.indexOf(interceptor);
            if (index > -1) {
                this.responseInterceptors.splice(index, 1);
            }
        };
    }
    /**
     * Runs all request interceptors in sequence
     *
     * @param ctx - Initial request context
     * @returns Modified request context after all interceptors
     */
    async runRequestInterceptors(ctx) {
        let current = ctx;
        for (const interceptor of this.requestInterceptors) {
            current = await interceptor(current);
        }
        return current;
    }
    /**
     * Runs all response interceptors in sequence
     *
     * @param ctx - Initial response context
     * @returns Modified response context after all interceptors
     */
    async runResponseInterceptors(ctx) {
        let current = ctx;
        for (const interceptor of this.responseInterceptors) {
            current = await interceptor(current);
        }
        return current;
    }
    /**
     * Clears all interceptors
     */
    clearAll() {
        this.requestInterceptors = [];
        this.responseInterceptors = [];
    }
}
//# sourceMappingURL=InterceptorManager.js.map